import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@/components/Navigation/Sidebar/sidebar.container"
    ).then((module) => ({
        default: module.Sidebar
    }))
);
